import Vue from 'vue'
import _ from 'lodash'
import {
  getContentfulPoll,
  getVotesForPoll
} from '@/api/trending'

const state = {
  selectedTrendingGames: {},
  polls: [],
  pollVoteCounts: {},
  userPollChoices: {}
}

const mutations = {
  'SET_SELECTED_TRENDING_GAMES': (state, payload) => {
    Vue.set(state, 'selectedTrendingGames', payload)
  },
  'SET_POLLS': (state, payload) => {
    Vue.set(state, 'polls', payload)
  },
  'UPDATE_OR_ADD_POLL': (state, payload) => {
    let pollEntryId = payload.entryId || null
    if (pollEntryId) {
      let poll = state.polls.find(poll => poll.entryId === pollEntryId)
      if (poll) {
        let index = state.polls.indexOf(poll)
        state.polls[index] = payload
      } else {
        state.polls.push(payload)
      }
      Vue.set(state, 'polls', state.polls)
    }
  },
  'UPDATE_POLL_OPTION_VOTE_COUNTS': (state, payload) => {
    let pollEntryId = payload.entryId || null
    let voteCounts = payload.voteCounts || null
    if (pollEntryId && voteCounts) {
      Vue.set(state.pollVoteCounts, pollEntryId, voteCounts)
    }
  },
  'INCREMENT_POLL_OPTION_VOTE_COUNT': (state, payload) => {
    let pollEntryId = payload.entryId || null
    let updateOption = payload.option || null
    if (pollEntryId && updateOption) {
      let voteCounts = state.pollVoteCounts[pollEntryId] || null
      let optionVoteCount = 0
      if (voteCounts) {
        optionVoteCount = (voteCounts[updateOption] || 0) + 1
        voteCounts[updateOption] = optionVoteCount
        Vue.set(state.pollVoteCounts, pollEntryId, voteCounts)
      }
    }
  },
  'SET_USER_POLL_CHOICE': (state, payload) => {
    let pollEntryId = payload.entryId || null
    let choice = payload.choice || null
    if (pollEntryId && choice) {
      Vue.set(state.userPollChoices, pollEntryId, choice)
    }
  }
}

const actions = {
  setSelectedTrendingGames ({ commit }, payload) {
    commit('SET_SELECTED_TRENDING_GAMES', payload)
  },
  async fetchPollByEntryId ({ commit, getters }, entryId) {
    // Check if poll exists in current store
    let poll = getters.getPollByEntryId(entryId)
    if (!poll) {
      // Fetch and store
      poll = await getContentfulPoll(entryId)
      commit('UPDATE_OR_ADD_POLL', poll)
    }
    return poll
  },
  async fetchPollUserVotes ({ commit, getters }, entryId) {
    let poll = getters.getPollByEntryId(entryId)
    if (poll) {
      let pollVotes = await getVotesForPoll(poll.id)
      let votes = _.get(pollVotes, 'poll.option_vote_counts', {})
      commit('UPDATE_POLL_OPTION_VOTE_COUNTS', {
        entryId: entryId,
        voteCounts: votes
      })

      let userVote = _.get(pollVotes, 'poll.user_choice', null)
      commit('SET_USER_POLL_CHOICE', {
        entryId: entryId,
        choice: userVote
      })
    }
  },
  storePoll ({ commit }, payload) {
    commit('UPDATE_OR_ADD_POLL', payload)
  }
}

const getters = {
  getSelectedTrendingGames: state => state.selectedTrendingGames,
  getPolls: state => state.polls,
  getPollByEntryId: state => entryId => state.polls.find(poll => poll.entryId === entryId),
  getPollVoteCounts: state => entryId => _.get(state.pollVoteCounts, entryId, null),
  getUserPollChoice: (state, getters) => entryId => {
    let poll = getters.getPollByEntryId(entryId)
    return poll ? _.get(state.userPollChoices, poll.entryId, null) : null
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/trending.js